import { createContext, useContext, useCallback, useRef } from 'react';

interface LoadingContextType {
  notifyLoaded: () => void;
}

export const LoadingContext = createContext<LoadingContextType | null>(null);

export const useLoadingNotification = () => {
  const context = useContext(LoadingContext);
  return context;
};

export const LoadingProvider = LoadingContext.Provider;
